/**
 * Staging — `ng build --configuration=staging` or `ng serve --configuration=staging`.
 */
export const environment = {
  production: true,
  envName: 'staging' as const,
  apiBaseUrl: 'https://apduatapi.katdev.com/api/v1',
  wsBaseUrl: 'https://apduatapi.katdev.com',
  superAdminApiUrl: 'https://apduatsuperadminapi.katdev.com/api/v1',
  customerFrontendUrl: 'https://apdcustomer.katdev.com',
  enablePermissionChecks: true,
  bypassAllPermissions: false,
};
